var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.333 19.205a4.666 4.666 0 0 1 4.66 4.41l.007.257v1.461a1.333 1.333 0 0 1-2.658.156l-.009-.156v-1.461a2 2 0 0 0-1.807-1.99l-.193-.01h-1.068a1.333 1.333 0 0 1-.155-2.658l.155-.009h1.068zm-21.598 0a1.333 1.333 0 0 1 .155 2.658l-.155.009H4.667a2 2 0 0 0-1.991 1.807l-.01.193v1.461a1.333 1.333 0 0 1-2.657.156L0 25.333v-1.461a4.666 4.666 0 0 1 4.41-4.66l.257-.007h1.068zM18.452 17.2a6 6 0 0 1 5.993 5.717l.007.283v2.134a1.333 1.333 0 0 1-2.658.156l-.009-.156V23.2a3.334 3.334 0 0 0-3.114-3.327l-.219-.007h-4.905a3.334 3.334 0 0 0-3.327 3.114l-.007.22v2.134a1.333 1.333 0 0 1-2.657.156l-.01-.156V23.2a6 6 0 0 1 5.718-5.994l.283-.006h4.905zm10.214-5.444a4.03 4.03 0 1 1-5.7 5.7 4.03 4.03 0 0 1 5.7-5.7zm-19.632 0a4.03 4.03 0 1 1-5.7 5.7 4.03 4.03 0 0 1 5.7-5.7zM19.88 6.94a5.487 5.487 0 1 1-7.76 7.76 5.487 5.487 0 0 1 7.76-7.76zm4.972 6.7a1.364 1.364 0 1 0 2.042.13l-.113-.13-.129-.113a1.364 1.364 0 0 0-1.8.114zm-19.632 0a1.364 1.364 0 1 0 2.042.13l-.114-.13-.128-.113a1.364 1.364 0 0 0-1.8.114zm8.786-4.814a2.82 2.82 0 1 0 4.145.17l-.157-.17-.17-.157a2.82 2.82 0 0 0-3.818.157z",
    fill: "#727DF9",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUsers);
export default __webpack_public_path__ + "static/media/icons-users.4aa8f0a31665ccb8a2cc331f2392c791.svg";
export { ForwardRef as ReactComponent };